<template>
  <v-row>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="350"
      max-height="450"
      v-for="(item, index) in dialogItems"
      :key="index"
      content-class="round"
    >
      <v-card class="primary">
        <v-card-title>
          <v-img
            alt="Psycp Logo"
            contain
            src="@/assets/LogoVertical.png"
            transition="scale-transition"
            height="180"
            class="mt-3"
          />
        </v-card-title>
        <v-card-text class="black--text align-text text-subtitle-2 text-center mt-3 pa-2">
          {{ item.message }}
        </v-card-text>
        <v-card-actions class="justify-space-around">
          <div class="d-flex flex-wrap text-center mb-7">
            <div>
              <v-tab @click="closeDialog()">
                <v-img
                  src="@/assets/Profesional.svg"
                  class="shrink"
                  style="position: relative"
                  width="100"
                  transition="scale-transition"
                  contain
                />
              </v-tab>
              <span>{{ item.client1 }}</span>
            </div>
            <div>
              <v-tab @click="insertRoute(item.homeIntroDialogTo)">
                <v-img
                  src="@/assets/Paciente.svg"
                  class="shrink"
                  style="position: relative"
                  width="97"
                  transition="scale-transition"
                  contain
                />
              </v-tab>
              <span>{{ item.client2 }}</span>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'VDialogIntro',
  props: ['dialogItems'],
  data() {
    return {
      dialog: true,
    };
  },
  methods: {
    insertRoute(ruta) {
      this.$router.push(ruta);
      this.$route.query;
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style>
.round {
  border-radius: 20px;
  overflow-y: hidden;
}
</style>
